import React from "react"
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

export default class GenericPopover extends React.Component 
{
    state = {
        popoverAnchorEl:null
    }
    handlePopoverOpen=event=>{
        //unless we've been asked to anchor to some other element on the screen, we'll anchor to the icon that spawned us
        const anchorEl = (this.props.externalAnchorElement)?this.props.externalAnchorElement:event.currentTarget
        this.setState({popoverAnchorEl: anchorEl})
    }
    handlePopoverClose=event=>{
        this.setState({popoverAnchorEl:null})
    } 
   
    maxWidth() {
        return (this.props.maxWidth)?this.props.maxWidth: this.defaultMaxWidth();
    }
    minWidth() {
        let min = (this.props.minWidth)?this.props.minWidth: this.defaultMinWidth();
        //if we've ended up with a min that's more than the max...
        //give the max priority (so we don't eclipse other content)
        if (min > this.maxWidth()) { 
            //unless ONLY min was specified
            if (!(this.minWidthSpecified() && !this.maxWidthSpecified())) {
                min = this.maxWidth()
            }
             
        }
        return min;
    }
    minWidthSpecified() { return (this.props.minWidth)?true:false}
    maxWidthSpecified() { return (this.props.maxWidth)?true:false}


    /*overridable methods*/
    defaultMaxWidth() { return ""; }
    defaultMinWidth() { return ""; }
    triggerIcon() {
        return (this.props.triggerIcon)?this.props.triggerIcon:<HelpOutlineIcon color="secondary"/>
    }
    contentBlurb() {
        return this.props.children;
    }
    callToAction() {
        return (this.props.callToAction)?this.props.callToAction:<></>
    }


    render() {
        return (
            <>
                <div style={{textAlign:"center", maxWidth:"100px"}}>
                    <IconButton onClick={this.handlePopoverOpen} >
                        {this.triggerIcon()}
                    </IconButton><br/>
                    {this.callToAction()}
                </div>

                <Popover 
                    onClose={this.handlePopoverClose}  
                    anchorEl={this.state.popoverAnchorEl} 
                    open={Boolean(this.state.popoverAnchorEl)} 
                    disableRestoreFocus>
                        <table>
                            <tbody>
                                <tr>
                                    <td valign="top" style={{padding:"10px",maxWidth:this.maxWidth(),minWidth:this.minWidth()}}>
                                        {this.contentBlurb()}
                                    </td>
                                    <td style={{maxWidth:"40px"}} valign="top" align="center">
                                        <IconButton onClick={this.handlePopoverClose} disableRipple={true}>
                                            <CloseIcon color="primary" fontSize="small"/>
                                        </IconButton>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </Popover>
            </>
        )
    }
  }